export default {"src":"/_next/static/media/adac-partnerLogo.403ad4e0.svg","height":30,"width":100};